<template>
    <div id="app">

        <header class="">
            <div class="logo">
                <img src="@/assets/img/logo3.png" alt="">
                <img src="@/assets/img/MISAWA-300.png" alt="" class="logo-misawa">
            </div>
        </header>

        <router-view/>

    </div>
</template>

<script>

export default {
    name: 'App',
    components: {
    },
    methods : {
        createTitleDesc(routeInstance) {
            //titleを設定する処理
            if(routeInstance.meta.title){
                var setTitle = routeInstance.meta.title + '｜住マイライフなび｜住まいと家計をシミュレーション！｜ミサワホーム';
                document.title = setTitle;
            } else {
                document.title = '住マイライフなび｜住まいと家計をシミュレーション！｜ミサワホーム';
            }

            // // メタタグのdescription設定処理
            // if(routeInstance.meta.desc){
            //     var setDesc = routeInstance.meta.desc + ' | 共通表示名';
            //     document.querySelector("meta[name='description']").setAttribute('content', setDesc)
            // } else {
            //     document.querySelector("meta[name='description']").setAttribute('content', 'ディスクリプションはありません')
            // }
        }
    },
    watch: {
        '$route'(routeInstance) {
            //ルートが変わった際にタイトルを変更するように監視している
            this.createTitleDesc(routeInstance);
        }
    },
    mounted(){
        var routeInstance = this.$route;
        this.createTitleDesc(routeInstance);
    }
}
</script>

<style lang="scss" >
html{scroll-behavior:smooth}
#app {
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #000;
}

body{
    background-color: #edf0f2 !important;

    &:before {
        background-color: #0c436f;
        content: "";
        display: block;
        height: 560px;
        left: 0;
        position: absolute;
        top: 0;
        -webkit-transform-origin: top;
        transform-origin: top;
        width: 100%;
    }
}


header{
    position: relative;

    height: 110px;
    padding: 20px 50px;

    .logo {
        max-width: 1024px;
        margin: auto;
        display: flex;
        justify-content: space-between;
        align-items: center;

        img{
            height: 70px;
            width: auto;

            &.logo-misawa {
                height: 45px;
            }
        }
    }

}

@media screen and (max-width: 768px) {
    header {
        height: 60px;
        padding: 10px 10px;

        .logo {

            img {
                height: 40px;

                &.logo-misawa {
                    height: 25px;
                }
            }

        }

    }

}


.wrap{
    position: relative;

    padding: 0 50px;

    .wrappedContent{
        position: relative;

        background: #fff;
        border-radius: 20px;
        max-width: 1024px;
        min-height: 540px;
        margin: auto;
        margin-bottom: 40px;
        padding: 10px 60px 30px 60px;

        box-shadow: 0 8px 10px rgb(0 45 89 / 16%);

        .wideHeader {
            position: relative;
            height: 70px;
            margin-bottom: 30px;

            .headerImg {
                position: absolute;
                width: 100%;
                max-width: 1024px;
            }

            .indicatorImg {
                height: 25px;
                margin-bottom: 6px;
            }

            h2 {
                font-size: 25px;
                font-weight: bold;
            }


        }

        .narrowHeader {
            padding-top: 15px;

            .indicatorImg {
                height: 20px;
                margin-bottom: 1px;
            }

            h2 {
                font-size: 25px;
                font-weight: bold;
            }
        }

        &.inputArea {
            .row{
                margin-bottom:10px;

                label {
                    margin-top: 9px;
                }
            }
        }

    }



}

@media screen and (max-width: 768px) {
    .wrap {
        padding: 0 10px;

        .wrappedContent {
            border-radius: 5px;
            padding: 20px;
            margin-bottom: 0;
        }

    }

    .inputAreaWrap {
        //margin-top: 25px;
    }
}


.detail-notice {
    font-size: 14px;
    color: #333;
}

.unit-label {
    color: #000;
    margin-left: 10px;
    display: inline-block;
    min-width: 45px;

    &.sub {
        color: #333;
        font-size: 13px;
        margin-left: 0;
    }

}
.input-description {
    font-size: 12px;
    padding-left: 20px;
    display: inline-block;
}

.btnBox {
    &:first-child{
        margin-bottom:10px ;
    }
    .btn{
        margin-right: 10px;
        background: #D8E0F2;
        color:#000;
        border: none;

        &.active{
            background: #E17470;
            color:#fff;
        }
    }
    &.small {
        .btn {
            padding: 3px 5px;
        }
    }

}
select, input{
    width: 150px;
    height: 36px;

    font-size: 21px !important;
    text-align: center;

    &.plaintext {
        background-color: transparent;
        border: solid transparent;
        border-width: 1px 0;
    }
}
input:focus::-webkit-input-placeholder {
    color: transparent;
}
input:focus::-moz-placeholder {
    color: transparent;
}
input:focus::-ms-input-placeholder {
    color: transparent;
}
input:focus::placeholder {
    color: transparent;
}

.btn-next-row {
    margin-top: 90px;

    .btn-next {
        width: 300px;
        background-color: #7598DA;
        color: #fff;
        font-weight: bold;
    }
}

.btn-prev-row {

    .btn-prev {
        width: 150px;
        background-color: #fff;
        color: #7598DA;
        font-weight: bold;
        margin-left:-150px;
    }
}

.openTri{
    display: inline;
    position: absolute;
    right: 10px;
    font-size: 14px;
    font-weight: normal;
    color: #444;

    .rounded-down-arrow {
        display: inline-block;
        position: relative;
        top: -1px;
        border-radius: 8px;
        width: 16px;
        height: 16px;
        padding-left: 2px;
        padding-top: 0px;
        font-size: 10px;
        margin-right: 2px;
        line-height: 16px;

        transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
        border: 1px solid;
        color: #586166;
        background-color: #fff;


    }

    &:hover .rounded-down-arrow {
        background-color: #586166;
        color: #fff;
    }

}


@media screen and (max-width: 1124px) {
    header div.headerSubImage{
        left:80px;
        margin-left:0;
    }
}

@media screen and (max-width: 768px) {
    header div.headerSubImage{
        left:20px;
        margin-left:0;
    }
}

@media screen and (max-width: 500px) {

    .wrap .wrappedContent .narrowHeader .col-7{
        padding: 0;
        padding-left: 10px;

        h2 {
            font-size: 20px;
        }

    }

    .btn{
        font-size: 12px!important;
    }

    label{
        font-size: 15px;
    }

    .col-4{
        padding-left: 0!important;
        padding-right: 0!important;
    }
    select, input{
        width: 75px;
    }

    .input-description {
        padding-left: 0;
    }

}

@media screen and (max-width: 400px) {
    .openTri {
        .openTri-text {
            display: none;
        }
    }
}

</style>
